<template>
  <button id="NUMBER_9" name="9" class="btn num-btn" data-vcode="NUMBER_9" aria-label="9 WXYZ">
    <div class="digit">9</div>
    <div class="letters">WXYZ</div>
  </button>
</template>
<script>
export default {};
</script>
